import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum TabKeyEnum {
  common = 'common',
  senior = 'senior',
  Valentine2022 = 'Valentine2022',
  RamadanBlindBox = 'RamadanBlindBox',
}

const typeMap = {
  [TabKeyEnum.common]: 1,
  [TabKeyEnum.senior]: 2,
  [TabKeyEnum.Valentine2022]: 3,
  [TabKeyEnum.RamadanBlindBox]: 4,
}
export const ChangeTab = createAsyncThunk(
  'ChangeTab',
  async (tabKey: TabKeyEnum, store) => {
    const resp = await http.post<HiyaRes<Omit<InitialStateType, 'TabKey'>>>(
      '/live/gift/blind_box',
      {
        ...store.getState().env.deviceinfo,
        type: typeMap[tabKey],
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
interface HiyaRes<T> {
  ret: number
  data: T
}
interface LuckyPlayerItemType {
  // 送礼用户名称
  name: string
  // 礼物价值
  gift_value: number
  // 礼物名称
  gift_name: string
}
export interface BlindBoxesItemType {
  // 礼物ID
  gift_id: number
  // 礼物名称
  gift_name: string
  // 礼物链接
  gift_url: string
  // 礼物价值
  gift_cost: number
}
interface InitialStateType {
  tabKey: TabKeyEnum
  blind_box_id?: number
  blind_box_cost?: number
  lucky_player?: Array<LuckyPlayerItemType>
  blind_boxes?: Array<BlindBoxesItemType>
}
const initialState: InitialStateType = {
  tabKey: TabKeyEnum.common,
}
export const GiftsBlindBoxSlice = createSlice({
  name: 'GiftsBlindBox',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(ChangeTab.pending, (state, action) => {
      return {
        tabKey: action.meta.arg,
      }
    })
    builder.addCase(ChangeTab.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default GiftsBlindBoxSlice.reducer
